import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  delete (context, data) {
    const path = 'medium/delete'
    Vue.axios.post(path, { id: data.id })
      .then(response => {
        context.commit('REMOVE_FROM_MEDIALIST', response.data[0])
      })
  },
  addMediumToMediaList  (context, payload) {
    context.commit('ADD_TO_MEDIALIST', payload)
  },
  async saveMediumToServer (context, payload) {
    if (!payload || !payload.data || !payload.data.id) {
      return console.log('no payload in Medium/actions/saveMediumToServer')
    }
    context.commit('SET_RELOADING_MEDIA', true)
    const path = 'medium/' + payload.data.id
    let reqParams = {}
    payload.columns.forEach(function (column, index) {
      reqParams[column] = payload.data[column]
    })
    await Vue.axios.patch(path, reqParams)
      .then(response => {
        context.commit('UPDATE_MEDIUM_IN_MEDIALIST', response.data)
        context.commit('SET_RELOADING_MEDIA', false)
        return response.data
      })
  },
  async getMedium (context, payload) {
    if (!payload || !payload.data || payload.data.id) return
    context.commit('SET_RELOADING_MEDIA', true)
    const path = 'medium/' + payload.data
    const populate = ['PlayListItems', 'MediumTags', 'Editors']
    if (payload.options && payload.options.populate === true) populate.push('File')
    const params = { params: { populate: populate.join(',') } }
    const medium = await Vue.axios.get(path, params)
      .then(response => {
        return response.data
      })
    context.commit('UPDATE_MEDIUM_IN_MEDIALIST', medium)
    context.commit('SET_RELOADING_MEDIA', false)
    return medium
  },
  setLocalPlaylistsCache (context, localPlayLists) {
    context.commit('SET_LOCAL_PLAYLIST_CACHE', localPlayLists)
  },
  clearList (context) {
    context.commit('SET_MEDIALIST', [])
    context.commit('CLEAR_MEDIA_TYPES')
    context.commit('CLEAR_SELECTED_LEFT')
    context.commit('CLEAR_SELECTED_RIGHT')
    context.commit('PAGINATION_SET_PAGE', ['left', 1])
    context.commit('PAGINATION_SET_PAGE', ['right', 1])
    context.commit('SET_MEDIA_TAGS_UNUSED', [])
    context.commit('SET_SELECTED_LIBRARY_FOLDER', {})
    context.commit('CLEAR_FILTER', 'left')
    context.commit('CLEAR_FILTER', 'right')
    context.commit('CLEAR_TYPE_FILTER', 'left')
    context.commit('CLEAR_TYPE_FILTER', 'right')
    context.commit('CLEAR_EDIT_HISTORY')
    context.commit('CLEAR_BREADCRUMBS')
  },
  analyzeList (context) {
    context.dispatch('setMediaTypes')
    context.dispatch('setMediaTags')
    // context.dispatch('setUnusedTags')
    context.dispatch('setUnusedMedia')
    setTimeout(() => {
      context.commit('SET_RELOADING_MEDIA', false)
    }, 0)
  },
  async getMediaList (context, doNotPopulate) {
    context.commit('SET_RELOADING_MEDIA', true)
    const path = 'medium/list'
    await Vue.axios.get(path)
      .then(response => {
        context.commit('SET_MEDIALIST', response.data)
      })
  },
  activateWsListener (context) {
    Vue.$io.socket.off('Medium_created')
    Vue.$io.socket.on('Medium_created', medium => {
      if (!this.state.User.liveMode.library) return
      context.commit('SET_RELOADING_MEDIA', true)
      context.commit('ADD_TO_MEDIALIST', medium)
      if (medium.type !== 'PlayListDesktop') {
        context.dispatch('analyzeList')
      } else {
        context.commit('SET_RELOADING_MEDIA', false)
      }
    })
    Vue.$io.socket.off('Medium_updated')
    Vue.$io.socket.on('Medium_updated', medium => {
      if (!this.state.User.liveMode.library) return
      context.commit('SET_RELOADING_MEDIA', true)
      context.commit('UPDATE_MEDIUM_IN_MEDIALIST', medium)
      context.commit('SET_RELOADING_MEDIA', false)
    })
    Vue.$io.socket.off('Medium_deleted')
    Vue.$io.socket.on('Medium_deleted', medium => {
      if (!this.state.User.liveMode.library) return
      console.log('Got Websocket info - Medium_deleted')
      context.commit('SET_RELOADING_MEDIA', true)
      context.commit('REMOVE_FROM_MEDIALIST', medium)
      context.dispatch('analyzeList')
    })
  },
  async setUnusedTags (context) {
    context.commit('SET_MEDIA_TAGS_UNUSED', (await Vue.axios.get('MediumTag/findUnused')).data)
  },
  async setUnusedMedia (context) {
    let mediaUsed = await Vue.axios.get('Medium/findMediaidsInAllDesktops')
      .then(response => {
        return response.data
      })
    context.commit('ADD_MEDIA_UNASSIGNED_TO_MEDIA_TYPES', mediaUsed)
  },
  async setMediaTags (context) {
    context.commit('SET_MEDIA_TAGS', (await Vue.axios.get('mediumtag/list')).data)
    context.commit('SET_MEDIA_TAGS_UNUSED', (await Vue.axios.get('MediumTag/findUnused')).data)
  },
  setMediaTypes (context) {
    context.commit('SET_MEDIA_TYPES')
  },
  deactivateWsListener (context) {
    Vue.$io.socket.off('Medium_created')
    Vue.$io.socket.off('Medium_updated')
  },
  async deleteEmptyFolderMedium (context, data) {
    let folderMediumId = data[0]
    const path = `medium/destroy`
    await Vue.axios.post(path, { mediumId: folderMediumId })
  },
  async duplicatePlaylist (context, playlist) {
    let targetFolderId
    if (context.state.selected_library_folder) {
      targetFolderId = context.state.selected_library_folder.id
    } else {
      targetFolderId = context.state.media_list.find(medium => medium.type === 'PlayListLibraryRoot').id
    }

    context.commit(
      'ADD_TO_MEDIALIST',
      (await Vue.axios
        .post('medium/duplicatePlaylist',
          {
            PlayList: playlist,
            libraryFolder: targetFolderId
          }
        )
      )
        .data)
  },
  async duplicatePlaylistRecursive (context, data) {
    let targetFolderId
    if (context.state.selected_library_folder) {
      targetFolderId = context.state.selected_library_folder.id
    } else {
      targetFolderId = context.state.media_list.find(medium => medium.type === 'PlayListLibraryRoot').id
    }

    context.commit(
      'ADD_TO_MEDIALIST',
      (await Vue.axios
        .post('medium/duplicatePlaylistRecursive',
          {
            PlayList: data.playlist.id,
            libraryFolder: targetFolderId,
            suffix: data.suffix
          }
        )
      )
        .data)
  },
  async duplicatePlaylistsRecursive (context, data) {
    const result = (await Vue.axios
      .post('medium/duplicatePlaylistsRecursive',
        {
          PlayLists: data.playlist,
          searchString: data.searchString,
          replaceString: data.replaceString
        }
      )
    )
      .data
    return result
  },
  async assignMediumToPlaylist (context, media) {
    const path = 'playlistitem/assignMediumToPlaylist'
    let parentId = media[0]
    let childrenIds = media[1]
    const resp = await Vue.axios.post(path, { Parent: parentId, Children: childrenIds, TargetPlayitemParams: context.state.dragged_over_playitem })
    return resp.data
  },
  async removePlayItemFromPlaylist (context, data) {
    let payload = null
    if (typeof data === 'object' && !Array.isArray(data)) {
      payload = data.id
    } else if (Array.isArray(data)) {
      payload = data
    }
    const path = 'playlistitem/delete'
    await Vue.axios.post(path, { id: payload })
  },
  async movePlaylistItemOrderRewrite (context, data) {
    const path = 'playlistitem/movePlaylistItemOrderRewrite'
    await Vue.axios.post(path, data)
  },
  async createPlaylist (context, PlayList) {
    const path = 'medium'
    let playlistMediumId
    await Vue.axios.post(path, PlayList)
      .then(response => {
        playlistMediumId = response.data.id
        context.commit('ADD_TO_MEDIALIST', response.data)
      })
    return playlistMediumId
  },
  async createPlaylistLibraryFolder (context, newPlayListFolder) {
    let newPlayListFolderMediumId
    await Vue.axios.post('medium', newPlayListFolder)
      .then(response => {
        newPlayListFolderMediumId = response.data.id
        context.commit('ADD_TO_MEDIALIST', response.data)
      })
    return newPlayListFolderMediumId
  },
  async getPlaylistContentSimple (context, data) {
    context.commit('SET_RELOADING_MEDIA', true)
    let medium
    let omitCalculateDurations
    if (data.hasOwnProperty('omitCalculateDurations')) {
      medium = data.medium
      omitCalculateDurations = data.omitCalculateDurations
    } else {
      medium = data
      omitCalculateDurations = false
    }
    const pl = (await Vue.axios.post('medium/getPlaylistContentSimple',
      { PlayList: medium.id, omitCalculateDurations }))
      .data
    context.commit('SET_RELOADING_MEDIA', false)
    return pl
  },
  // TAGS
  async deleteMediumTagFromMedium (context, data) {
    data[1] = isNaN(data[1]) && data[1].id ? data[1].id : data[1]
    const result = await Vue.axios.post('mediumtag/removeFromMedium', {
      mediumId: data[1],
      tagId: data[0]
    })
    if (result.data === 'removed') {
      context.commit('DELETE_TAG_FROM_MEDIUM', data)
    }
  },
  async addMediumTagToMedium (context, data) {
    data[1] = isNaN(data[1]) && data[1].id ? data[1].id : data[1]
    await Vue.axios.post('mediumtag/addToMedium', {
      mediumId: data[1],
      tagId: data[0]
    })
  },
  async saveMediumTagInNetwork (context, tag) {
    await Vue.axios.patch('mediumtag/' + tag.id, tag)
    context.dispatch('setMediaTags')
  },
  async deleteMediumTagFromNetwork (context, tagId) {
    await Vue.axios.delete('mediumtag/' + tagId)
    context.dispatch('setMediaTags')
  },
  async addMediumTag (context, tagname) {
    const tag = (await Vue.axios.post('mediumtag', { 'name': tagname })).data
    context.commit('ADD_MEDIUM_TAG_TO_NETWORK_MEDIUM_TAGS', tag)
    return tag
  },
  async replaceMediumTagsInMedium (context, [tagIdsArray, mediumId]) {
    await Vue.axios.put('medium/' + mediumId + '/MediumTags', tagIdsArray)
    await Vue.axios.post('medium/createModificationForMedium', { mediumId })
    await context.dispatch('setUnusedTags')
    await context.dispatch('setMediaTags')
  },
  toggleTagToListFilter (context, tag) {
    context.commit('TOGGLE_TAG_TO_LIST_FILTER', tag)
  },
  updateCollection (context, mediaCollection) {
    context.commit('UPDATE_MEDIALIST', mediaCollection)
  },
  async refreshPlaylist (context, playlistMediumId) {
    const playlist = await context.dispatch('Medium/getMedium', {
      data: playlistMediumId,
      options: { populate: true }
    }, { root: true })
    context.commit('UPDATE_MEDIUM_IN_MEDIALIST', playlist)
  },
  // SELECTIONS
  toggleMediumSelectedLeft (context, medium) {
    context.commit('TOGGLE_MEDIUM_SELECTED_LEFT', medium)
  },
  toggleMediumSelectedRight (context, medium) {
    context.commit('TOGGLE_MEDIUM_SELECTED_RIGHT', medium)
  },
  addMediumSelectedLeft (context, medium) {
    context.commit('ADD_MEDIUM_SELECTED_LEFT', medium)
  },
  removeMediumSelectedLeft (context, medium) {
    context.commit('REMOVE_MEDIUM_SELECTED_LEFT', medium)
  },
  removeMediumSelectedRight (context, medium) {
    context.commit('REMOVE_MEDIUM_SELECTED_RIGHT', medium)
  },
  setSelectedLeft (context, media) {
    context.commit('SET_SELECTED_LEFT', media)
  },
  addSelectedRight (context, media) {
    context.commit('ADD_SELECTED_RIGHT', media)
  },
  clearMediaSelectedLeft (context) {
    context.commit('CLEAR_SELECTED_LEFT')
  },
  clearMediaSelectedRight (context) {
    context.commit('CLEAR_SELECTED_RIGHT')
  },
  setDropAllowed (context, boolean) {
    context.commit('SET_DROP_ALLOWED', boolean)
  },
  setDraggedOverPlayitem (context, data) {
    context.commit('SET_DRAGGED_OVER_PLAYITEM', data)
  },
  resetDraggedOverPlayitem (context) {
    context.commit('RESET_DRAGGED_OVER_PLAYITEM')
  },
  setMediumSelectedLeftDragged (context, value) {
    context.commit('SET_DRAGGED_MEDIUM', value)
  },
  // PAGINATION
  paginationSetLimit (context, data) {
    console.log(data)
    context.commit('PAGINATION_SET_LIMIT', data)
  },
  paginationSetPage (context, data) {
    context.commit('PAGINATION_SET_PAGE', data)
  },
  // FILTER
  setTagsInFilter (context, data) {
    context.commit('SET_TAGS_IN_FILTER', data)
  },
  toggleTagInFilter (context, data) {
    context.commit('TOGGLE_TAG_IN_FILTER', data)
  },
  toggleTypeInFilter (context, data) {
    context.commit('TOGGLE_TYPE_IN_FILTER', data)
  },
  setTypeInFilter (context, data) {
    context.commit('SET_TYPE_IN_FILTER', data)
  },
  setSelectedLibraryFolder (context, data) {
    context.commit('SET_SELECTED_LIBRARY_FOLDER', data)
  },
  setBiggestTypeInFilter (context, side) {
    context.commit('SET_BIGGEST_TYPE_IN_FILTER', side)
  },
  setTagAllAnyInFilter (context, data) {
    context.commit('SET_TAG_ALLANY_IN_FILTER', data)
  },
  clearFilter (context, side) {
    context.commit('CLEAR_FILTER', side)
  },
  toggleShowThumbs (context) {
    context.commit('TOGGLE_SHOW_THUMBS')
  },
  toggleTagFilterVisible (context) {
    context.commit('TOGGLE_TAG_FILTER_VISIBLE')
  },
  // PATH
  addMediumIdToMediaEditHistory (context, medium) {
    context.commit('ADD_MEDIUMID_TO_MEDIA_EDIT_HISTORY', medium)
  },
  // BREADCRUMBS
  addMediumIdToBreadcrumbs (context, mediumId) {
    context.commit('ADD_MEDIUMID_TO_BREADCRUMBS', mediumId)
  },
  clearBreadcrumbs (context) {
    context.commit('CLEAR_BREADCRUMBS')
  },
  stripBreadcrumbs (context, index) {
    context.commit('STRIP_BREADCRUMBS', index)
  },
  // SEARCH STRING
  updateSearchString (context, string) {
    context.commit('UPDATE_SEARCH_STRING', string)
  }
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/medium/medium.actions.js
// module id = null
// module chunks = 